var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"text-center",attrs:{"colSpan":_vm.colspan}},[_c('i',{staticClass:"fas fa-spinner fa-spin mr-1"}),_vm._v(" Cargando ... ")])])}
var staticRenderFns = []

export { render, staticRenderFns }